import { render } from "./units-modal.vue?vue&type=template&id=0505f097"
import script from "./units-modal.vue?vue&type=script&lang=js"
export * from "./units-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__